<template>
  <div class="columns">
    <div class="column is-2">
      <!-- <strong>Año</strong> -->
      <div class="field has-addons">
        <p class="control">
          <button class="button is-primary" @click="selectyear('-')">
            <span class="icon">
              <span class="material-icons">keyboard_arrow_left</span>
            </span>
          </button>
        </p>
        <p class="control">
          <button class="button">
            <span>{{year}}</span>
          </button>
        </p>
        <p class="control">
          <button class="button is-primary" @click="selectyear('+')">
            <span class="icon">
              <span class="material-icons">keyboard_arrow_right</span>
            </span>
          </button>
        </p>
      </div>
    </div>
    <div class="column">
      <!-- <strong>Mes</strong> -->
      <div class="field has-addons">
        <p class="control">
          <button class="button" @click="selectmonth(1)" :class="monthclass(1)">
            <span>Ene</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(2)" :class="monthclass(2)">
            <span>Feb</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(3)" :class="monthclass(3)">
            <span>Mzo</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(4)" :class="monthclass(4)">
            <span>Abr</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(5)" :class="monthclass(5)">
            <span>Myo</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(6)" :class="monthclass(6)">
            <span>Jun</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(7)" :class="monthclass(7)">
            <span>Jul</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(8)" :class="monthclass(8)">
            <span>Ago</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(9)" :class="monthclass(9)">
            <span>Sep</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(10)" :class="monthclass(10)">
            <span>Oct</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(11)" :class="monthclass(11)">
            <span>Nov</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="selectmonth(12)" :class="monthclass(12)">
            <span>Dic</span>
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      year: 0,
      month: [],
      staticmonth: 0
    };
  },
  props:{
    options: Object // se le puede definir year "2020" month [1] isrange "true" en caso que quiera seleccionar rango
  },
  computed: {
    ...mapState(["empresa"])
  },
  methods: {
    monthclass(month) {
      if (month === this.staticmonth) {
        return "is-dark";
      } else {
        if (this.month.indexOf(month) !== -1) {
          return "is-primary";
        } else {
          return "";
        }
      }
    },
    selectyear(sign) {
      if (sign === "+") {
        this.year++;
      } else {
        this.year--;
      }
    },
    selectmonth(selectedmonth) {
      const _this = this;
      if (this.staticmonth === 0) {
        // no tiene seleccionado un mes estatico
        if (this.month.indexOf(selectedmonth) === -1) {
          // el mes seleccionado es distinto al mes seleccionado anteriormente
          this.month = [];
          this.month.push(selectedmonth);
        } else {
          // el mes seleccionado es el mismo que ya habia seleccionado por lo tanto lo vuelve estatico
          if(this.options && this.options.isrange){
            this.staticmonth = selectedmonth;
          }
        }
      } else {
        // si tiene seleccionado un mes estatico
        if (selectedmonth === this.staticmonth) {
          // si el mes seleccionado es igual al estatico le quita lo estatico y deja como seleccionado el mes en cuestion y borra el rango de meses
          this.staticmonth = 0;
          this.month = [];
          this.month.push(selectedmonth);
        } else {
          let first;
          let last;
          if (this.staticmonth > selectedmonth) {
            last = this.staticmonth + 1;
            first = selectedmonth + 1;
          } else {
            last = selectedmonth + 1;
            first = this.staticmonth + 1;
          }
          this.month = [];
          this.month.push(first - 1);

          for (let i = first; i < last; i++) {
            _this.month.push(i);
          }
        }
      }
    }
  },
  watch: {
    year(nv, ov) {
      if (nv !== ov) {
        this.$emit("period", { year: this.year, months: this.month });
      }
    },
    month(nv, ov) {
      if (nv !== ov) {
        this.$emit("period", { year: this.year, months: this.month });
      }
    }
  },
  created(){
    const today = new Date();
    this.year = this.options && this.options.year ? this.options.year : today.getFullYear();
    this.month = this.options && this.oprions.month ? this.options.month : [today.getMonth()+1]
  }
};
</script>


// WEBPACK FOOTER //
// src/components/commons/Periodselector.vue